"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Skeleton.default;
  }
});

var _Skeleton = _interopRequireDefault(require("./Skeleton"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/Skeleton/index.js
// module id = 365
// module chunks = 0